module.exports = __webpack_public_path__ + "static/media/steps.ce3c6f02.svg";